<div class="statistics-selection-container">
  <mat-form-field appearance="fill" class="statistics-form">
    <mat-label>Felhasználók szűrése</mat-label>
    <mat-select [formControl]="users" multiple (selectionChange)="refreshChart()">
      <mat-option
        *ngFor="let item of userList;"
        [value]="item"
        class="statistics-option"
      >{{item.username}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="statistics-button-container">
    <app-button
      (click)="selectAll()"
      [title]="'Mind'"
      [fontSize]="18"
    ></app-button>
    <app-button
      (click)="deselectAll()"
      [title]="'Egyik sem'"
      [fontSize]="18"
    ></app-button>
  </div>
</div>

<app-basic-chart
  [chartDataSubject]="chartRefreshSubject"
></app-basic-chart>

<app-basic-chart
  [chartDataSubject]="globalChartRefreshSubject"
></app-basic-chart>
